(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[203],{

/***/ 2219:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...genericPath]]",
      function () {
        return __webpack_require__(2731);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _instanceof = (__webpack_require__(6856)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _react = _interopRequireDefault(__webpack_require__(7294));
var _loadable = _interopRequireDefault(__webpack_require__(4302));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 6319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _react = _interopRequireDefault(__webpack_require__(7294));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 4302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var _class_call_check = (__webpack_require__(9658)/* ["default"] */ .Z);
var _create_class = (__webpack_require__(7222)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(7294));
var _loadableContext = __webpack_require__(6319);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var useSyncExternalStore = ( true ? __webpack_require__(7294) : 0).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _class_call_check(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _create_class(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            var _this1 = this;
                            this._delay = setTimeout(function() {
                                _this1._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        var _this2 = this;
                        this._timeout = setTimeout(function() {
                            _this2._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 2731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _genericPath_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/utils/wa.ts
var wa_window = __webpack_require__.g.window;
var callWAReq = function() {
    postCallWAReq();
};
function postCallWAReq() {
    try {
        if (!sessionStorage.getItem("__tmpRef")) {
            var ref;
            if (((ref = document.referrer) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                sessionStorage.setItem("__tmpRef", document.referrer);
            }
        }
        clearWAParam();
        var pvar = {
            content: "0",
            server: "secure-sg",
            page_url: document.location,
            referrer: sessionStorage.getItem("__tmpRef")
        };
        WATrackerTrackPageView(pvar);
        sessionStorage.setItem("__tmpRef", document.location.toString());
    } catch (e) {}
}
var clearWAParam = function() {
    try {
        wa_window.s.pageName = undefined;
        wa_window.s.prop1 = undefined;
        wa_window.s.prop10 = undefined;
        wa_window.s.eVar10 = undefined;
        wa_window.s.eVar31 = undefined;
        wa_window.s.prop7 = undefined;
        wa_window.s.eVar7 = undefined;
        if (sessionStorage.getItem("__tmpRef")) {
            wa_window.s.prop6 = sessionStorage.getItem("__tmpRef");
        }
    } catch (e) {}
};
var WATrackerTrackPageView = function(eventId) {
    if (typeof wa_window.WATracker !== "undefined" && wa_window.WATracker) {
        try {
            wa_window.WATracker.trackPageView(eventId);
        } catch (err) {
            console.log("WATrackerTrackPageView", err);
        }
    }
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/WATracks.tsx





var WATracker = function() {
    var ref = (0,react.useState)(false), isWATrackerLoaded = ref[0], setIsWATrackerLoaded = ref[1];
    var ref1 = (0,react.useState)(false), isVisitorApiLoaded = ref1[0], setIsVisitorApiLoaded = ref1[1];
    var ref2 = (0,react.useState)(false), isAdrumConfigLoaded = ref2[0], setIsAdrumConfigLoaded = ref2[1];
    var router = (0,next_router.useRouter)();
    // call trackPageView on routeChangeComplete
    (0,react.useEffect)(function() {
        var handleRouteChange = function() {
            callWAReq();
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router.events
    ]);
    //adrum-config
    (0,react.useEffect)(function() {
        var window1 = window;
        window1["adrum-start-time"] = new Date().getTime();
        (function(config) {
            (function(xhr) {
                xhr.exclude = {
                    urls: [
                        {
                            pattern: ".*glassbox.*",
                            type: "regex"
                        }, 
                    ]
                };
            })(config.xhr || (config.xhr = {}));
        })(window1["adrum-config"] || (window1["adrum-config"] = {}));
        (function(config) {
            config.appKey = "EUM-AAB-AXY";
            config.adrumExtUrlHttp = "http://cdn.appdynamics.com";
            config.adrumExtUrlHttps = "https://cdn.appdynamics.com";
            config.beaconUrlHttps = "https://apm.cld.hkjc.com";
            config.xd = {
                enable: false
            };
            config.spa = {
                spa2: true
            };
        })(window1["adrum-config"] || (window1["adrum-config"] = {}));
        setIsAdrumConfigLoaded(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://common.hkjc.com/wa/VisitorAPI.js",
                type: "text/javascript",
                onLoad: function() {
                    setIsVisitorApiLoaded(true);
                }
            }),
            isVisitorApiLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "text/javascript",
                src: "https://common.hkjc.com/wa/wa_tracker.js",
                onLoad: function() {
                    setIsWATrackerLoaded(true);
                }
            }),
            isWATrackerLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "text/javascript",
                src: "https://common.hkjc.com/wa/wa_tracker_config.js",
                onLoad: function() {
                    callWAReq();
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "text/javascript",
                src: "https://common.hkjc.com/wa/glassbox.js"
            }),
            isAdrumConfigLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://cdn.appdynamics.com/adrum/adrum-21.7.0.3493.js"
            })
        ]
    });
};
/* harmony default export */ var WATracks = (WATracker);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/common/gql/queryBranchMap.ts
var QueryBranchMapPage = '\nfragment branchInfoFragment on OCBInfo {\n  key: name\n  template: template {\n    name\n  }\n  branchId: field(name: "BranchId") {\n    value\n  }\n  branchName: field(name: "BranchName") {\n    value\n  }\n  branchDistrict {\n    targetItem {\n      key: name\n      ... on OCBDistrict {\n        region {\n          targetItem {\n            ... on OCBRegion {\n              regionName {\n                value\n              }\n            }\n          }\n        }\n        districtName {\n          value\n        }\n      }\n    }\n  }\n  branchAddress: field(name: "BranchAddress") {\n    value\n  }\n}\n\nfragment OCBRemarkFragment on OCBRemarks {\n  key: name\n  RemarksContent: field(name: "RemarksContent") {\n    value\n  }\n  RemarksIcon: remarksIcon {\n    ... on ImageField {\n      src(maxWidth: null)\n    }\n  }\n  Enabled: field(name: "Enabled") {\n    value\n  }\n}\n\nfragment branchAddressInfoFragment on OCBAddressInfo {\n  branchBasicInfo: branchId {\n    targetItem {\n      ...branchInfoFragment\n    }\n  }\n  addressSupplement {\n    value\n  }\n  branchImage: branchImage {\n    ... on ImageField {\n      src(maxWidth: null)\n    }\n  }\n  latitude {\n    value\n  }\n  longitude {\n    value\n  }\n  remarks {\n    targetItems {\n      ...OCBRemarkFragment\n    }\n  }\n  serviceHour {\n    value\n  }\n}\n\nfragment RegionDistrictFragment on OCBDistrict {\n  key: name\n  region {\n    targetItem {\n      ... on OCBRegion {\n        regionName {\n          value\n        }\n      }\n    }\n  }\n  districtName {\n    value\n  }\n}\n\nfragment OptionsFragment on OCBServicesHour {\n  key: name\n  serviceHour: field(name: "ServiceHour") {\n    value\n  }\n}\n\nfragment PageGenericFragment on PageGeneric {\n  frontendPageComponent {\n    targetItem {\n      ComponentName: field(name: "ComponentName") {\n        value\n      }\n    }\n  }\n}\n\nfragment ServiceHoursAddressPage on BranchPage {\n  pageTitle {\n    value\n  }\n  header: headerText {\n    value\n  }\n}\n\nquery SpecialPage($path: String!, $lang: String!) {\n  Content: item(path: $path, language: $lang) {\n    key: name\n    ...PageGenericFragment\n    ...ServiceHoursAddressPage\n  }\n  BranchInfo: item(path: "/sitecore/content/Sites/JCBW/OCB Branch Address Info/", language: $lang) {\n    children {\n      ...branchAddressInfoFragment\n    }\n  }\n  RegionDistrict: item(path: "/sitecore/content/Sites/JCBW/Misc/OCBDistrictOptions/", language: $lang) {\n    children {\n      ...RegionDistrictFragment\n    }\n  }\n  ServiceHourOption: item(path: "/sitecore/content/Sites/JCBW/Misc/OCBServiceHourOptions", language: $lang) {\n    children {\n      ...OptionsFragment\n    }\n  }\n  OCBRemarks: item(path: "/sitecore/content/Sites/JCBW/OCB Remarks", language: $lang) {\n    children {\n      ...OCBRemarkFragment\n    }\n  }\n}\n';

;// CONCATENATED MODULE: ./src/common/gql/queryLuckyOcb.ts
var QueryLuckyOcbPage = '\nfragment PageGenericFragment on PageGeneric {\n  frontendPageComponent {\n    targetItem {\n      ComponentName: field(name: "ComponentName") {\n        value\n      }\n    }\n  }\n}\n\nfragment branchInfoFragment on OCBInfo {\n  key: name\n  template: template {\n    name\n  }\n  branchId: field(name: "BranchId") {\n    value\n  }\n  branchName: field(name: "BranchName") {\n    value\n  }\n  branchDistrict {\n    targetItem {\n      ... on OCBDistrict {\n        region {\n          targetItem {\n            ... on OCBRegion {\n              regionName {\n                value\n              }\n            }\n          }\n        }\n        districtName {\n          value\n        }\n      }\n    }\n  }\n\n  branchAddress: field(name: "BranchAddress") {\n    value\n  }\n}\n\nfragment branchAddressInfoFragment on OCBAddressInfo {\n  branchBasicInfo: branchId {\n    targetItem {\n      ...branchInfoFragment\n    }\n  }\n  addressSupplement {\n    value\n  }\n  latitude {\n    value\n  }\n  longitude {\n    value\n  }\n}\nfragment LuckyOCBPageFragment on LuckyOCBPage {\n  header: field(name: "HeaderText") {\n    value\n  }\n  pageTitle {\n    value\n  }\n  tableTitle {\n    value\n  }\n  tableFootnote {\n    value\n  }\n  yearColumns{\n    value\n  }\n  data: children {\n    ...LuckyOCBRecordFragment\n  }\n}\nfragment LuckyOCBRecordFragment on LuckyOCBRecord {\n  key: name\n  branchId {\n    targetItem {\n      ...branchAddressInfoFragment\n    }\n  }\n  yearWinningRecord: field(name: "YearWinningRecord") {\n    value\n  }\n  enabled: field(name: "Enabled") {\n    value\n  }  \n}\n\nquery SpecialPage($path: String!, $lang: String!) {\n  Content: item(path: $path, language: $lang) {\n    key: name\n    ...PageGenericFragment\n    ...LuckyOCBPageFragment\n  }\n}\n';

;// CONCATENATED MODULE: ./src/common/gql/queryPayoutTime.ts
var QueryPayoutTime = '\nfragment PageGenericFragment on PageGeneric {\n  frontendPageComponent {\n    targetItem {\n      ComponentName: field(name: "ComponentName") {\n        value\n      }\n    }\n  }\n}\n\nfragment C__PageGenericFragment on C__PageGeneric {\n  title: field(name: "PageTitle") {\n    value\n  }\n  purename: field(name: "NamePureText") {\n    value\n  }\n  name: field(name: "Name") {\n    value\n  }\n  description: field(name: "Description") {\n    value\n  }\n  data: children {\n    key: name\n    template {\n      name\n    }\n    ...PayoutTimeFragment\n  }\n}\n\nfragment PayoutTimeFragment on PayoutTime {\n  key: name\n  template: template {\n    name\n  }\n  title: field(name: "PageTitle") {\n    value\n  }\n  NoticeMessage: field(name: "NoticeMessage") {\n    value\n  }\n  NoticeEnabled: field(name: "NoticeEnabled") {\n    value\n  }\n  tournamentInfo {\n    targetItems {\n      ... on FootballTournamentInfo {\n        tournamentName: tournamentName {\n          value\n        }\n        tournamentCode: tournamentCode {\n          value\n        }\n        tournamentIcon: tournamentIcon {\n          ... on ImageField {\n            src(maxWidth: null)\n          }\n        }\n      }\n    }\n  }\n  TournamentInfoEnabled: field(name: "TournamentInfoEnabled") {\n    value\n  }\n  Remarks: field(name: "Remarks") {\n    value\n  }\n  RemarksEnabled: field(name: "RemarksEnabled") {\n    value\n  }\n}\n\nquery SpecialPage($path: String!, $lang: String!) {\n  Content: item(path: $path, language: $lang) {\n    key: name\n    ...PageGenericFragment\n    ...C__PageGenericFragment\n  }\n}\n';

;// CONCATENATED MODULE: ./src/common/gql/querySellingHours.ts
var QuerySellingHours = 'fragment FootballSellingHoursFragment on FootballSellingHoursRow {\n  key: name\n  date {\n    value: dateValue\n  }\n  matchDate {\n    value\n  }\n  digitalChannel {\n    value\n  }\n  telebet {\n    value\n  }\n  telebetAutomated {\n    value\n  }\n  branch {\n    value\n  }\n  racecourses {\n    value\n  }\n}\nfragment FootballSellingHoursDatasetFragment on FootballSellingHoursDataset{\n  key: name    \n  datasetDisplayName{\n    value\n  }\n   data: children {\n        ...FootballSellingHoursFragment\n  }\n}\n\nquery FootballSellingHoursQuery($lang: String!) {\n  Content: item(path: "/sitecore/content/Sites/JCBW/Information/Special/Special Page/info/football/selling-hours/", language: $lang) {\n    title: field(name: "PageTitle") {\n      value\n    }\n    footnote: field(name: "Footer"){\n            value\n    }\n    data: children {  \n      ...FootballSellingHoursDatasetFragment\n    }\n  }\n}\n';

;// CONCATENATED MODULE: ./src/common/pageMapping.ts





var AppContent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(46), __webpack_require__.e(624)]).then(__webpack_require__.bind(__webpack_require__, 4624));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4624)
            ];
        }
    }
});
var pageMapping = {
    LuckyOCBComponent: {
        component: dynamic_default()(function() {
            return Promise.all(/* import() */[__webpack_require__.e(255), __webpack_require__.e(480)]).then(__webpack_require__.bind(__webpack_require__, 8480));
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(8480)
                    ];
                }
            }
        }),
        query: QueryLuckyOcbPage
    },
    BranchMapPageComponent: {
        component: dynamic_default()(function() {
            return Promise.all(/* import() */[__webpack_require__.e(255), __webpack_require__.e(234), __webpack_require__.e(350)]).then(__webpack_require__.bind(__webpack_require__, 4350));
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(4350)
                    ];
                }
            }
        }),
        query: QueryBranchMapPage
    },
    PayoutTimePageComponent: {
        component: AppContent,
        query: QueryPayoutTime
    },
    SellingHoursPageComponent: {
        component: dynamic_default()(function() {
            return Promise.all(/* import() */[__webpack_require__.e(885), __webpack_require__.e(214)]).then(__webpack_require__.bind(__webpack_require__, 7214));
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(7214)
                    ];
                }
            }
        }),
        query: QuerySellingHours
    }
};

;// CONCATENATED MODULE: ./src/pages/[[...genericPath]].tsx





var GenericPage = function(props) {
    var ref;
    var PageContentComponent = (ref = pageMapping[props.frontendPageComponent]) === null || ref === void 0 ? void 0 : ref.component;
    var PageContent = null;
    if (PageContentComponent) {
        PageContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContentComponent, (0,_object_spread/* default */.Z)({}, props));
    } else {
        PageContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(AppContent, (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WATracks, {}),
            PageContent
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _genericPath_ = (GenericPage);


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(638)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(699)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(2219); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);